module.exports = __webpack_public_path__ + "static/media/MD_headshot_1610055041093.2320bfe5.jpg";